import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '_helpers';

// create slice

const name = 'patient';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const patientActions = { ...slice.actions, ...extraActions };
export const patientReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        patient: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/users`;

    return {
        getPatient: getPatient()
    };    

    function getPatient() {
        return createAsyncThunk(
            `${name}/getPatient`,
            async () => await fetchWrapper.get(baseUrl)
        );
    }
}

function createExtraReducers() {
    return {
        ...getPatient()
    };

    function getPatient() {
        var { pending, fulfilled, rejected } = extraActions.getPatient;
        return {
            [pending]: (state) => {
                state.users = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.users = action.payload;
            },
            [rejected]: (state, action) => {
                state.users = { error: action.error };
            }
        };
    }
}
